import { MainApi } from "./MainApi";

export class UserApi {
  static baseUrl = `${MainApi.urlPrefix}/user`;

  static getDetailInfo = () => () => MainApi.api.get(`${UserApi.baseUrl}/detail-info`);
}
